import { render, staticRenderFns } from "./ListTransition.vue?vue&type=template&id=2d8c49aa&scoped=true"
import script from "./ListTransition.vue?vue&type=script&lang=js"
export * from "./ListTransition.vue?vue&type=script&lang=js"
import style0 from "./ListTransition.vue?vue&type=style&index=0&id=2d8c49aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c49aa",
  null
  
)

export default component.exports